var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 7.19999H5.59842V4.00001C5.59842 2.67682 6.67523 1.60001 7.99842 1.60001C9.32161 1.60001 10.3984 2.67682 10.3984 4.00001V4.8H11.9984V4.00001C11.9984 1.79441 10.204 0 7.99842 0C5.79282 0 3.99845 1.79441 3.99845 4.00001V7.19999C3.11604 7.19999 2.39844 7.91681 2.39844 8.80001V14.4C2.39844 15.2824 3.11604 16 3.99845 16H11.9984C12.8816 16 13.5984 15.2824 13.5984 14.4V8.80001C13.5984 7.91681 12.8816 7.19999 11.9984 7.19999ZM7.99842 12.8C7.33602 12.8 6.79842 12.2624 6.79842 11.6C6.79842 10.9376 7.33602 10.4 7.99842 10.4C8.66082 10.4 9.19842 10.9376 9.19842 11.6C9.19842 12.2624 8.66082 12.8 7.99842 12.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/Disabled.c93636178ef0f9780f84c7df6d2d394e.svg";
export { ForwardRef as ReactComponent };